import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import { CocoonMark } from "@/components/CocoonMark";
import { AdoptionLLM } from "@/components/AdoptionLLM";
import { Footer } from "@/components/Footer";

export default function QuiParleIA() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-background" data-testid="page-qui-parle-ia">
      <header className="fixed top-0 inset-x-0 z-50 glass">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
          <Link to="/" className="flex items-center gap-2 sm:gap-2.5 whitespace-nowrap" data-testid="brand-logo">
            <img src="/cocoon-logo-glow.png" alt="COCOON MIND" className="h-9 sm:h-10 w-auto select-none" style={{ filter: "drop-shadow(0 0 8px hsl(28 96% 56% / 0.30))" }} />
            <span className="font-display text-lg sm:text-2xl tracking-tight"><CocoonMark withMind /></span>
          </Link>
          <Link to="/" data-testid="back-home-btn" className="inline-flex items-center gap-2 text-sm text-foreground/70 hover:text-primary transition-colors">
            <ArrowLeft size={16} /> {t("nav.back")}
          </Link>
        </div>
      </header>
      <main className="pt-20 pb-4">
        <AdoptionLLM />
      </main>
      <Footer />
    </div>
  );
}
